import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  permissions: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action) {
      const { token, data } = action.payload;

      state.isAuthenticated = true;
      state.token = token;
      state.user = {
        id: data.id,
        name: data.name,
        email: data.email,
        uuid: data.uuid,
        roleId: data.roleId,
      };

      const perms = [];

      data.role?.rolePermissions?.forEach((perm) => {
        const resource = perm.permission.name;
        if (perm.add == 1) perms.push(`${resource}.add`);
        if (perm.edit == 1) perms.push(`${resource}.edit`);
        if (perm.remove == 1) perms.push(`${resource}.remove`);
        if (perm.view == 1) perms.push(`${resource}.view`);
        if (perm.menu == 1) perms.push(`${resource}.menu`);
        if (perm.approveLevel1 == 1) perms.push(`${resource}.approveLevel1`);
        if (perm.approveLevel2 == 1) perms.push(`${resource}.approveLevel2`);
      });

      state.permissions = perms;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.permissions = [];
      localStorage.removeItem('persist:auth');
      localStorage.removeItem('token');
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
